import '../styles/filterBar.css'
import ReactPaginate from "react-paginate";

export const FilterBar = ({setSearchParams, pageCount, changePage, id}) =>
{
    const onSearch = (event) =>
    {
        const {value} = event.target;
        if (value.length < 3)
        {
            setSearchParams((params) =>
            {
                params.delete("search");
                return params;
            })
        }
        else
        {
            setSearchParams((params) =>
            {
                params.set("search", value)
                return params;
            })
        }
    }

    const onSort = (event) =>
    {
        const value = event.target.innerText;
        setSearchParams((params) =>
        {
            params.set("sort_by", value)
            return params;
        })
    }

    return <div class="filterBar" id={id}>
    <nav id="min" class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <div className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Sort by</a>
            <ul className="dropdown-menu">
                <li><span className="dropdown-item" onClick={onSort}>Title</span></li>
                <li><span className="dropdown-item" onClick={onSort}>Price</span></li>
                <li><span className="dropdown-item" onClick={onSort}>Release</span></li>
                <li><span className="dropdown-item" onClick={onSort}>Rating</span></li>
            </ul>
        </div>
        <ReactPaginate previousLabel={"Previous"} nextLabel={"Next"} pageCount={pageCount} onPageChange={changePage}
        containerClassName="paginator" pageClassName='pageBtn' previousLinkClassName='pageBtn' nextLinkClassName='pageBtn'
        disabledLinkClassName='disabledBtn' activeClassName='activeBtn'/>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          </ul>
          <form class="d-flex">
            <input class="form-control me-2 background" type="search" placeholder="Search" aria-label="Search" onInput={onSearch}></input>
            <button id="btn" class="btn btn-outline-warning" type="submit">Search</button>
          </form>
        </div>
      </div>
    </nav>
  </div>
    
    
    
    // <div className="filterBar">
    //     <ul className="navbar-nav">
    // //         <li className="nav-item dropdown">
    // //             <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Sort by</a>
    // //             <ul className="dropdown-menu">
    // //                 <li><span className="dropdown-item" onClick={onSort}>Title</span></li>
    // //                 <li><span className="dropdown-item" onClick={onSort}>Price</span></li>
    // //                 <li><span className="dropdown-item" onClick={onSort}>Release</span></li>
    // //                 <li><span className="dropdown-item" onClick={onSort}>Rating</span></li>
    // //             </ul>
    // //         </li>
    //     </ul>
    //     <input className="form-control" type="search" placeholder="Search" aria-label="Search" onInput={onSearch}/>
    // </div>
    
    
    
    // <div className="container fluid">
    //     <nav className="navbar navbar-expand-lg navbar-light bg-light">
    //         <ul className="navbar-nav">
    //             <li className="nav-item dropdown">
    //                 <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Sort by</a>
    //                 <ul className="dropdown-menu">
    //                     <li><span className="dropdown-item" onClick={onSort}>Title</span></li>
    //                     <li><span className="dropdown-item" onClick={onSort}>Price</span></li>
    //                     <li><span className="dropdown-item" onClick={onSort}>Release</span></li>
    //                     <li><span className="dropdown-item" onClick={onSort}>Rating</span></li>
    //                 </ul>
    //             </li>
    //             <li className="nav-item">
    //                 <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" onInput={onSearch}/>
    //             </li>
    //         </ul>
    //     </nav>
    // </div>
}